import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-ts-client',
	templateUrl:'./TypeScriptClientPluginPage.html',
	styles: [],
	styleUrls:['./TypeScriptClientPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class TypeScriptClientPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_663 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>typescript-client</artifactId>
</dependency>
\`\`\``;
	mdContent_664 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:typescript-client:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_665 = `\`\`\`java
@NgComponent("my-widget")
public class MyWidget extends DivSimple<MyWidget>
        implements INgComponent<MyWidget> {

    @NgField("title = 'Hello World'")
    String title;

    @NgOnInit
    public void onInit() {
        add(new Paragraph<>().setText("{{ title }}"));
    }
}
\`\`\``;
	mdContent_666 = `\`\`\`java
@NgComponent("settings-page")
@NgRoutable(path = "settings", parent = {AppComponent.class})
@NgRouteData(key = "title", value = "'Settings'")
public class SettingsPage extends DivSimple<SettingsPage>
        implements INgComponent<SettingsPage> { }
\`\`\``;
	mdContent_667 = `\`\`\`java
@NgComponent("my-widget")
public class MyWidget extends DivSimple<MyWidget>
        implements INgComponent<MyWidget> {

    @NgField("title = 'Hello World'")
    String title;

    @NgOnInit
    public void onInit() {
        add(new Paragraph<>().setText("{{ title }}"));
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
